<div class="flex justify-center px-5 md:px-12 lg:px-27 md:pt-4 pb-12">
  <ng-container>
    <ng-container *ngIf="reviewExists$ | async; let reviewExists; else noReview">
      <div class="flex justify-center items-center flex-col h-[70vh]">
        <span class="text-center body-m-text text-text-primary mb-6" i18n>You have already sent feedback about this ride</span>
        <button class="primary-button" type="button" routerLink="/home" i18n>Back to home page</button>
      </div>
    </ng-container>
    <ng-template #noReview>
      <div class="center-flex-col" *ngIf="booking.status == RideBookingStatus.Completed">
        <h1 class="text-text-primary h2-text text-center mb-4" i18n>Rate your ride</h1>
        <!-- <div class="booking-details text-text-primary bg-white my-4 p-4 border rounded-xl shadow">
          <h2 class="body-m-text font-semibold mb-2" i18n>Booking Details</h2>
          <p *ngIf="currentUserId == booking.travellerUserId">
            <strong i18n>Driver</strong>
            <strong>:</strong>
            {{booking.driverName}}
          </p>
          <p *ngIf="currentUserId == booking.driverId">
            <strong i18n>Rider</strong>
            <strong>:</strong>
            {{booking.travellerName}}
          </p>
          <p><strong i18n>Start Location</strong><strong>:</strong> {{ booking.startLocationName }}</p>
          <p><strong i18n>End Location</strong><strong>:</strong> {{ booking.endLocationName }}</p>
          <button class="secondary-button-transparent w-full mt-4"
            [routerLink]="currentUserId == booking.driverId ?
             ['/booking', booking.id, 'review'] : 
             ['/booking', booking.id]" i18n>View details</button>
        </div> -->
        <div>
          <!-- <p class="text-text-primary body-m-text my-2" i18n>Share your experience </p> -->
          <app-star-rating [rating]="rating" [starCount]="starCount"
            (ratingUpdated)="onRatingChanged($event)">
          </app-star-rating>
          
          <mat-form-field class="w-full">
            <mat-label i18n>Your feedback</mat-label>
            <textarea rows="7" maxlength="1000" matInput i18n-placeholder placeholder="Please provide your feedback about your ride"
              [(ngModel)]="reviewText" name="reviewTextArea">
              </textarea>
          </mat-form-field>
          <button class="primary-button w-full" type="submit" [disabled]="rating == 0" (click)="submitReview()" i18n>Send feedback</button>
        </div>
      </div>
      <div *ngIf="booking.status != RideBookingStatus.Completed"
        class="flex justify-center items-center flex-col text-text-primary body-m-text h-[70vh]">
        <span class="text-center body-m-text mb-6" i18n>Your ride is ongoing, happy travelling!</span>
        <button class="primary-button" type="button" routerLink="/home" i18n>Back to home page</button>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loading>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>